import { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { useGetUsersByRole } from "../../../../../api/jeep-rally/users/users.hooks";
import VisitorsHeader from "./_components/VisitorsHeader";
import VisitorsTable from "./_components/VisitorsTable";
import {
  filterVisitors,
  getVisitorApiErrorMessage,
  normalizeVisitors,
} from "./utils/visitors.utils";

const VisitorsListPage = () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const { data, isLoading, isError, error } = useGetUsersByRole("visitor");

  const visitors = useMemo(() => normalizeVisitors(data), [data]);

  const filteredVisitors = useMemo(
    () => filterVisitors(visitors, searchTerm),
    [visitors, searchTerm]
  );

  const handleView = (visitor) => {
    const visitorId = visitor?._id || visitor?.id;
    if (!visitorId) return;
    history.push(`/jeep-rally/participants/visitors/view/${visitorId}`, {
      visitor,
    });
  };

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-danger py-4">
            Failed to load visitors.{" "}
            {getVisitorApiErrorMessage(error, "Please try again.")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <VisitorsHeader
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          total={filteredVisitors.length}
        />
        <div className="card-body">
          {filteredVisitors.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-0">No visitors found</p>
            </div>
          ) : (
            <VisitorsTable
              visitors={filteredVisitors}
              onView={handleView}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VisitorsListPage;
